import React from 'react';

const RemoveButton = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="var(--SELECTED)" />
    <path
      d="M18.4999 11.4C19.1074 11.4 19.5999 11.8925 19.5999 12.5C19.5999 13.067 19.1709 13.5338 18.6198 13.5936L18.4999 13.6H5.4999C4.89239 13.6 4.3999 13.1075 4.3999 12.5C4.3999 11.933 4.82891 11.4662 5.38005 11.4065L5.4999 11.4H18.4999Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export default RemoveButton;
